export default {"src":"https://static.spiritory.com/_next/static/media/spiritory.0564f59c.svg","height":1001,"width":1476,"blurWidth":0,"blurHeight":0};